import {Injectable, NgZone} from '@angular/core';

import {Observable, Observer} from 'rxjs';

import {ExgMapCircleComponent} from '../../exg-map-circle/exg-map-circle.component';
import {ExgMapGoogleAPIWrapper} from '../exg-map-google-api-wrapper.service';

@Injectable()
export class ExgMapCircleManagerService {
  private _circles: Map<ExgMapCircleComponent, Promise<google.maps.Circle>> =
    new Map<ExgMapCircleComponent, Promise<google.maps.Circle>>();

  constructor(private _apiWrapper: ExgMapGoogleAPIWrapper, private _zone: NgZone) {
  }

  addCircle(circle: ExgMapCircleComponent): void {
    this._circles.set(circle, this._apiWrapper.getNativeMap().then(() =>
      this._apiWrapper.createCircle({
        center: {lat: circle.latitude, lng: circle.longitude},
        clickable: circle.clickable,
        draggable: circle.draggable,
        editable: circle.editable,
        fillColor: circle.fillColor,
        fillOpacity: circle.fillOpacity,
        radius: circle.radius,
        strokeColor: circle.strokeColor,
        strokeOpacity: circle.strokeOpacity,
        strokePosition: google.maps.StrokePosition[circle.strokePosition] as any,
        strokeWeight: circle.strokeWeight,
        visible: circle.visible,
        zIndex: circle.zIndex,
      }))
    );
  }

  /**
   * Removes the given circle from the map.
   */
  removeCircle(circle: ExgMapCircleComponent): Promise<void> {
    // @ts-ignore
    return this._circles.get(circle).then((c) => {
      c.setMap(null);
      this._circles.delete(circle);
    });
  }

  async setOptions(circle: ExgMapCircleComponent, options: google.maps.CircleOptions) {
    // @ts-ignore
    return this._circles.get(circle).then((c) => {
      const actualParam = options.strokePosition as any as keyof typeof google.maps.StrokePosition;
      options.strokePosition = google.maps.StrokePosition[actualParam];
      c.setOptions(options);
    });
  }

  getBounds(circle: ExgMapCircleComponent): Promise<google.maps.LatLngBounds> {
    // @ts-ignore
    return this._circles.get(circle).then((c) => c.getBounds());
  }

  getCenter(circle: ExgMapCircleComponent): Promise<google.maps.LatLng> {
    // @ts-ignore
    return this._circles.get(circle).then((c) => c.getCenter());
  }

  getRadius(circle: ExgMapCircleComponent): Promise<number> {
    // @ts-ignore
    return this._circles.get(circle).then((c) => c.getRadius());
  }

  setCenter(circle: ExgMapCircleComponent): Promise<void> {
    // @ts-ignore
    return this._circles.get(circle).then(
      c => c.setCenter({lat: circle.latitude, lng: circle.longitude}));
  }

  setEditable(circle: ExgMapCircleComponent): Promise<void> {
    // @ts-ignore
    return this._circles.get(circle).then(c => c.setEditable(circle.editable));
  }

  setDraggable(circle: ExgMapCircleComponent): Promise<void> {
    // @ts-ignore
    return this._circles.get(circle).then(c => c.setDraggable(circle.draggable));
  }

  setVisible(circle: ExgMapCircleComponent): Promise<void> {
    // @ts-ignore
    return this._circles.get(circle).then(c => c.setVisible(circle.visible));
  }

  setRadius(circle: ExgMapCircleComponent): Promise<void> {
    // @ts-ignore
    return this._circles.get(circle).then(c => c.setRadius(circle.radius));
  }

  getNativeCircle(circle: ExgMapCircleComponent): Promise<google.maps.Circle> {
    // @ts-ignore
    return this._circles.get(circle);
  }

  createEventObservable<T>(eventName: string, circle: ExgMapCircleComponent): Observable<T> {
    return new Observable((observer: Observer<T>) => {
      let listener: google.maps.MapsEventListener | null = null;
      // @ts-ignore
      this._circles.get(circle).then((c) => {
        listener = c.addListener(eventName, (e: T) => this._zone.run(() => observer.next(e)));
      });

      return () => {
        if (listener !== null) {
          listener.remove();
        }
      };
    });
  }
}
